import { render, staticRenderFns } from "./Accountant.vue?vue&type=template&id=15ac0c9c&"
import script from "./Accountant.vue?vue&type=script&lang=js&"
export * from "./Accountant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports